import React from 'react';

import BlueprintTitvCard from './BlueprintTitvCard';
import SectionHeader from './SectionHeader';
import { Section, SectionItem } from './types';

interface BlueprintTitvSectionProps {
  section: Section;
  onPlayVideo?: (item: SectionItem) => void;
}

const BlueprintTitvSection = ({ section, onPlayVideo }: BlueprintTitvSectionProps) => {
  return (
    <article>
      <SectionHeader title={section.title} anchorId={section.anchorId} />
      <div className="mt-40 grid grid-cols-1 gap-y-40 sm:grid-cols-2 sm:gap-x-[52px] lg:grid-cols-3 lg:gap-x-24 lg:gap-y-64">
        {section.items.map((item) => (
          <BlueprintTitvCard key={item.id} item={item} onPlay={onPlayVideo} />
        ))}
      </div>
    </article>
  );
};

export default BlueprintTitvSection;
